import { render, staticRenderFns } from "./CmgClearWalletModal.vue?vue&type=template&id=7f2ff6c6&scoped=true&lang=pug&"
import script from "./cmg-clear-wallet-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-clear-wallet-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgClearWalletModal.vue?vue&type=style&index=0&id=7f2ff6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ff6c6",
  null
  
)

export default component.exports